import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTRPC } from 'src/utils/trpc';

import { invalidateChangeRequestFeeds } from '../invalidateChangeRequestFeeds';

export const useDeleteActionsTRPC = () => {
  const trpc = useTRPC();
  const queryClient = useQueryClient();
  const mutation = useMutation({
    ...trpc.frontend.action.delete.mutationOptions({
      onSuccess: async (result) => {
        // RSP-5789 — the bulk gate partitions the batch; any ids that
        // required approval got a CR created server-side. Surface those on
        // the CR read surfaces immediately instead of waiting for the
        // panel's next poll.
        if (result.changeRequestIds.length > 0) {
          await invalidateChangeRequestFeeds(queryClient, trpc);
        }
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.action.register.queryKey(),
        });
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.action.actionById.queryKey(),
        });
      },
    }),
  });

  return {
    deleteActions: async (variables: { Ids: string[] }): Promise<void> => {
      await mutation.mutateAsync({ Ids: variables.Ids });
    },
    loading: mutation.isPending,
    error: mutation.error,
  };
};
